<style lang="scss">
.monitorMachineMoldTable .el-progress-bar__outer {
  background: #606672;
}

.monitorMachineMoldTable .el-progress__text {
  color: #ffffff;
}

.monitorMachineMoldTable::before {
  z-index: inherit;
}

.monitorMachineMoldTable.el-table {
  background-color: transparent;
}

.monitorMachineMoldTable.el-table--border:after,
.monitorMachineMoldTable.el-table--group:after,
.monitorMachineMoldTable.el-table:before {
  background-color: transparent;
}

.monitorMachineMoldTable.el-table tr {
  background-color: transparent;
}

.monitorMachineMoldTable.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #33333a !important;
}

.monitorMachineMoldTable .el-table td.gutter,
.monitorMachineMoldTable.el-table th.gutter {
  background: transparent;
}

//.monitorMachineMoldTable .el-table__body-wrapper {
//  background: #1d1d24;
//}

// 滚动条的宽度
.monitorMachineMoldTable .el-table__body-wrapper::-webkit-scrollbar {
  width: 2px; // 横向滚动条
}

// 滚动条的滑块
.monitorMachineMoldTable .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #419fff;
  border-radius: 2px;
}

/*滚动条里面轨道*/
// .monitorMachineMoldTable .el-table__body-wrapper::-webkit-scrollbar-track {
// 	border-radius: 2px;
// 	background: #1D1D24;
// }
</style>

<style lang="scss" scoped="scoped">
.cell-class-name {
  border-bottom: 1px solid red !important;
}
</style>

<template>
  <div ref="container" style="overflow: auto;height: 100%;position: relative;padding: 20px;" :style="{ background: $attrs.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE == 'black' ? '#1D1D24' : '#000466' }">
    <div ref="titleBar" class="titleBar" style="display: flex;justify-content: space-between;align-items:center ;padding-bottom: 10px;">
      <div style="display: flex;align-items: center;">
        <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
        <p style="font-size: 16px;line-height: 22px;color: #F4F4F4;">
          {{ $t('mojuweixiuzhong') }}
        </p>
      </div>
    </div>
    <div :style="{ height: contentHeight + 'px' }">
      <el-table ref="table" class="monitorMachineMoldTable" :data="list" style="width: 100%" :max-height="contentHeight" :row-style="{ background: $attrs.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE == 'black' ? '#1d1d24' : '#000355', height: rowHeight + 'px' }" :cell-style="{ padding: 0 + 'px', borderColor: 'transparent', color: '#FFFFFF', 'font-size': '14px' }" :header-cell-style="{ background: $attrs.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE == 'black' ? '#33333A' : '#151599', color: '#C0C4CC', padding: '0px', height: '42px', borderColor: 'transparent', 'font-size': '14px' }" cell-class-name="cell-class-name">
        <el-table-column :label="$t('mojubianhao')">
          <template slot-scope="scope">
            <div style="font-size: 14px;font-weight: bold;">
              {{ $t(scope.row.mouldNo) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('mojumingcheng')">
          <template slot-scope="scope">
            <div style="font-size: 14px;font-weight: bold;">
              {{ $t(scope.row.mouldName) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('chuangjianshijian')">
          <template slot-scope="scope">
            <div style="font-size: 14px;font-weight: bold;">
              {{ dayjs.unix(scope.row.createTime / 1000).format('MM-DD HH:mm') }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('kaishiweixiuren')">
          <template slot-scope="scope">
            <div style="font-size: 14px;font-weight: bold;">
              {{ $t(scope.row.startRepairerNickname) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('guzhangmiaoshu')">
          <template slot-scope="scope">
            <div style="font-size: 14px;font-weight: bold;">
              {{ $t(scope.row.faultDescription) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('weixiuzhuangtai')">
          <template slot-scope="scope">
            <div style="font-weight: bold;font-size: 14px;border-radius: 2px;height: 30px;width: 76px;display: flex;justify-content: center;align-items: center;color:rgba(255, 58, 94, 1) ;border:1px solid rgba(255, 58, 94, 1) ;background-color: rgba(255, 58, 94, 0.2);">
              {{ $t({ '0': 'daichuli', '1': 'weixiuzhong', '2': 'yiwancheng' }[scope.row.status]) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('jinjichengdu')">
          <template slot-scope="scope">
            <div :style="{ 'background-color': { '0': 'rgba(250, 186, 20, 1)', '1': 'rgba(250, 108, 28, 1)', '2': 'rgba(245, 34, 45, 1)' }[scope.row.level] }" style="font-weight: bold;font-size: 14px;border-radius: 2px;height: 30px;width: 76px;display: flex;justify-content: center;align-items: center;color:white;">
              {{ $t({ '0': 'yiban', '1': 'jinji', '2': 'teji' }[scope.row.level]) }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_monitor_machine_model_machine_wait',
  components: {},
  watch: {
    '$attrs.orgId'(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.listData();
    }
  },
  data() {
    return {
      interval: null,
      timer: null,
      contentHeight: 0,
      rowHeight: 0,
      list: [],

      isStopListScroll: false
    };
  },
  created() {
    this.timer = setInterval(() => {
      this.listData();
    }, 120000);
    this.listData();
  },
  mounted() {
    this.resize();
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
    this.setAutoScroll();
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    async listData() {
      let response = await this.http.get('/web/report/page/board_repair_record?status=1&pageSize=999', {
        params: {
          //orgId: this.$attrs.orgId,
        }
      });
      this.list = response.data.rows;
    },
    setAutoScroll() {
      if (this.interval) {
        clearInterval(this.interval);
      }
      const listDiv = this.$refs.table.bodyWrapper;
      this.interval = setInterval(() => {
        if (!this.store.state.is_monitor_full) {
          return;
        }
        if (!this.isStopListScroll) {
          listDiv.scrollTop += 1 / window.devicePixelRatio + 0.05;
          if (listDiv.clientHeight + listDiv.scrollTop >= listDiv.scrollHeight) {
            this.isStopListScroll = true;
            setTimeout(() => {
              if (listDiv.clientHeight + listDiv.scrollTop >= listDiv.scrollHeight) {
                listDiv.scrollTop = 0;
              }
              this.isStopListScroll = false;
            }, 5000);
          }
        }
      }, 100);
    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.$refs.titleBar) {
          return;
        }
        this.contentHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 20 - 20;
        this.rowHeight = (this.contentHeight - 42 - 5) / 4;
      }, 800);
    }
  }
};
</script>
